import React from 'react';

import { CloudDownload } from '@mui/icons-material';
import { Box, Button, Paper } from '@mui/material';

import ClearAllButton from './delete/ClearAllButton';
import HelpButton from './help/HelpButton';

type Props = {
    onDeleteAllConfirm: () => void;
    onDownload: () => void;
};

const MiscTools = React.memo((props: Props) => (
    <Paper elevation={2}>
        <Box padding="1.5px">
            <HelpButton />
            <Button sx={{ display: 'none', minWidth: 0, padding: '0.45rem', margin: '1.5px' }} onClick={props.onDownload} color="inherit" variant="contained" disableElevation>
                <CloudDownload/>
            </Button>
            <ClearAllButton {...props}/>
        </Box>
    </Paper>
));

export default MiscTools;
